/* eslint-disable @typescript-eslint/no-misused-promises */

import Image from 'next/image'
import React from 'react'
import styles from './scannerDetails.module.scss'
import { DOWNLOAD_APP, SCAN_TO_DOWNLOAD, SCANNER_ALT, SCANNER_TEXT, APP_DOWNLOAD_PROMPT, WIDGET_LOGO_ALT } from './commonConstants'
import { commonWidgetConfig } from './commonWidgetConfig'
import { LOCK_ICON } from './widgetImagesConstant'
import { onDownloadApp } from './helper'

const ScannerDetails = ({ regNo, segmentEventCommonProperties, widgetType, phone, userData, vehicleData }) => (
  <div className={styles.scannerContainer}>
    <div className={styles.scannerWrapper}>
      <div className={styles.scannerInfo}>
        <Image src={LOCK_ICON} alt={WIDGET_LOGO_ALT.LOCK_ICON} width={25} height={25} />
        <h4>{SCANNER_TEXT}</h4>
        <h5>{APP_DOWNLOAD_PROMPT}</h5>
      </div>
      <div className={styles.scannerImage}>
        <Image src={commonWidgetConfig.scannerImg[widgetType]} width={125} height={125} alt={SCANNER_ALT} />
        <span>{SCAN_TO_DOWNLOAD}</span>
      </div>
           <div
        className={styles.downloadBtn}
        onClick={() =>
          onDownloadApp({ regNo, segmentEventCommonProperties, widgetType, phone, userData, vehicleData })
        }>
        <span>{DOWNLOAD_APP}</span>
      </div>
    </div>
  </div>
)

export default ScannerDetails
